import Box from "@mui/material/Box";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { GoogleAuthScript } from "@portal/app/_components/scripts/GoogleAuthScript";
import { SignInType } from "@portal/app/login/SignInFlowController";

export const GoogleAuth = ({
  onClick,
  onSuccess,
  propsToContainer,
  signInType,
}: {
  onClick?: () => void;
  onSuccess?: (response: google.accounts.id.CredentialResponse) => void;
  propsToContainer?: React.ComponentProps<typeof Box>;
  signInType: SignInType;
}) => {
  const router = useRouter();
  const [signUpElement, setSignUpElement] = useState<HTMLDivElement | null>(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.google?.accounts) {
      setInitialized(true);
    }
  }, [router]);

  useEffect(() => {
    if (typeof window !== undefined && signUpElement && initialized) {
      google.accounts.id.renderButton(signUpElement, {
        type: "standard",
        theme: "outline",
        size: "large",
        text: signInType === "CREATE_ACCOUNT" ? "signup_with" : "signin_with",
        shape: "rectangular",
        logo_alignment: "center",
        width: signUpElement.clientWidth,
        click_listener: function () {
          onClick?.();
        },
      });
    }
  }, [initialized, onClick, signInType, signUpElement]);

  return (
    <GoogleSignInContainer {...propsToContainer}>
      <GoogleAuthScript
        onReady={() => {
          google.accounts.id.initialize({
            client_id: process.env.GOOGLE_OAUTH_CLIENT_ID as string,
            callback: (response) => onSuccess?.(response),
          });
          setInitialized(true);
        }}
      />
      <Box
        width="100%"
        ref={(current: HTMLDivElement) => {
          setSignUpElement(current);
        }}
      />
    </GoogleSignInContainer>
  );
};

const GoogleSignInContainer = styled(Box)`
  width: 100%;
  "& iframe": {
    transform: scale(1.5);
  }
`;
